import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utStyle.css';
import config from '../../config.json';
import UTLabel from './utLabel';

const apiUrl = config.apiUrl;

const UTDelete = () => {
    const [undertimeDetails, setUndertimeDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const navigate = useNavigate();
    const { undertimeId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchUndertimeData = async () => {
            setIsDisable(true);
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Undertime/${undertimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch undertime data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setUndertimeDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching undertime data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchUndertimeData();
    }, []);

    const handleDelete = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Undertime/Delete/${undertimeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setErrorMessage('');
                setSuccessMessage(data.Message);
                setIsDisable(false);
                navigate('/undertime-list');
            }
        } catch (error) {
            setErrorMessage('Error deleting undertime');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
    } = undertimeDetails;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasStandard) ? (
                <>
                    <h3>Delete Undertime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleDelete}>
                        <div className="row mt-4">
                            <UTLabel label="Transaction ID" value={TransactionID} />
                            <UTLabel label="Transaction Date" value={TransactionDate} />
                            <UTLabel label="Employee" value={Employee.Name} />
                            <UTLabel label="Date Start" value={DateStart} />
                            <UTLabel label="Date End" value={DateEnd} />
                            <UTLabel label="Duration" value={Duration} />
                            <UTLabel label="Remarks" value={Remarks} />
                            <UTLabel label="Status" value={Status} />
                        </div>

                        <div className="mb-2">
                            <Link to="/undertime-list" className="btn btn-secondary me-2">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    disabled={isDisable}
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default UTDelete;
